import React, { useState } from 'react';
import EventCard from 'components/eventCard';
import { EventGrid, EventTab, EventTabs, EventsCard } from '../index.styled';

interface GroupEventsSectionProps {
  upcomingEvents: any[];
  pastEvents: any[];
}

const GroupEventsSection = ({ upcomingEvents, pastEvents }: GroupEventsSectionProps) => {
  const [eventTab, setEventTab] = useState<'upcoming' | 'past'>('upcoming');
  const displayedEvents = eventTab === 'upcoming' ? upcomingEvents : pastEvents;

  return (
    <EventsCard>
      <EventTabs>
        <EventTab active={eventTab === 'upcoming'} onClick={() => setEventTab('upcoming')}>
          Upcoming Events
        </EventTab>
        <EventTab active={eventTab === 'past'} onClick={() => setEventTab('past')}>
          Past Events
        </EventTab>
      </EventTabs>
      <EventGrid>
        {displayedEvents.map((event) => (
          <EventCard key={event.id} {...event.attributes} id={event.id} />
        ))}
      </EventGrid>
    </EventsCard>
  );
};

export default GroupEventsSection;
